import { Component, input, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RoleDTO } from '@api/models';
import { TranslatePipe } from '@ngx-translate/core';
import { MultiSelectChangeEvent, MultiSelectModule } from 'primeng/multiselect';
import { noop } from 'rxjs';

@Component({
  selector: 'app-role-select',
  imports: [MultiSelectModule, TranslatePipe, FormsModule],
  templateUrl: './role-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: RoleSelectComponent,
    },
  ],
})
export class RoleSelectComponent implements ControlValueAccessor {
  roles = input.required<RoleDTO[]>();
  disabled = signal(false);
  selectedRoles = signal<RoleDTO[]>([]);

  private onTouched: () => void = noop;
  private onChange: (_: RoleDTO[]) => void = noop;

  onRoleChange(event: MultiSelectChangeEvent): void {
    this.setValue(event.value as RoleDTO[], true);
  }

  writeValue(value: RoleDTO[]): void {
    this.setValue(value, false);
  }

  registerOnChange(onChange: (value: RoleDTO[]) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  private setValue(value: RoleDTO[], emitEvent: boolean): void {
    this.selectedRoles.set(value);
    if (emitEvent && this.onChange) {
      this.onChange(value);
      this.onTouched();
    }
  }
}
